import * as React from 'react'

export const Download = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={15} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.656 11.133A.489.489 0 0 0 8 11.25c.094 0 .219-.03.313-.117l4.5-3.75c.218-.147.218-.469.03-.645-.155-.205-.5-.205-.687-.029L8.5 9.756V.469C8.5.234 8.25 0 8 0c-.281 0-.5.234-.5.469v9.287L3.812 6.68c-.187-.147-.53-.147-.687.058-.188.176-.188.498.031.645l4.5 3.75ZM14 9.375h-1.5c-.281 0-.5.234-.5.469 0 .263.219.469.5.469H14c.531 0 1 .439 1 .937v1.875c0 .527-.469.938-1 .938H2c-.563 0-1-.41-1-.938V11.25c0-.498.438-.938 1-.938h1.5c.25 0 .5-.205.5-.468 0-.235-.25-.469-.5-.469H2c-1.125 0-2 .85-2 1.875v1.875C0 14.18.875 15 2 15h12c1.094 0 2-.82 2-1.875V11.25c0-1.025-.906-1.875-2-1.875Zm-.25 2.813c0-.381-.344-.704-.75-.704-.438 0-.75.323-.75.704 0 .41.313.703.75.703.406 0 .75-.293.75-.704Z"
      fill="#282421"
    />
  </svg>
)
